import { nioJsBridge } from '@nio-wad/universal-bridge-h5';

/**
 * @fuction  [版本号]
 * @xfshz
 * @DateTime 2022-08-11T11:06:46+0800
 * @param    {string}                 v1 [description]
 * @param    {string}                 v2 [description]
 */
export function compareVersions(v1: string, v2: string) {
  const pa = v1.split('.');
  const pb = v2.split('.');
  for (let i = 0; i < 3; i++) {
    const na = Number(pa[i]);
    const nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  return 0;
}

export const isInApp = [
  'nio-lifestyle',
  'Lifestyle',
  'niopower',
  'NIOPower',
  'NioPower',
  '_dsbridge',
  'webview/lg',
].some((flag) => navigator.userAgent.indexOf(flag) > -1);

export const getEnv = async () => {
  if (isInApp) {
    const appInfo = await nioJsBridge.getAppInfo();
    return appInfo.data?.env || 'prod';
  }
  let env = 'prod';
  if (typeof window !== 'undefined' && window.location) {
    const domain = window.location.hostname;

    // 本地开发环境
    if (domain === 'localhost' || domain === '127.0.0.1') {
      env = 'test';
    }
    // 测试环境域名模式
    else if (domain.includes('-test') || domain.includes('.test.')) {
      env = 'test';
    }
    // 开发环境域名模式
    else if (domain.includes('-dev') || domain.includes('.dev.')) {
      env = 'dev';
    }
    // 预发布环境域名模式
    else if (domain.includes('-stg') || domain.includes('.stg.')) {
      env = 'stg';
    }
    // 本地环境域名模式（IP地址等）
    else if (domain.includes('-local') || domain.includes('.local.')) {
      env = 'local';
    }
    // 生产环境
    else {
      env = 'prod';
    }
  }
  return env;
};

/**
 * 判断是否是鸿蒙
 * @returns
 */
export const isHarmonyOS = () => {
  const ua = navigator.userAgent;
  return ua.toLowerCase().includes('harmony');
};


const openMapNormal = async (
  latitude: string,
  longitude: string,
  addressName: string
) => {
  console.log('openMapNormal');
  return nioJsBridge.openMap({
    data: {
      latitude: String(latitude),
      longitude: String(longitude),
      addressName,
    },
  });
};

const openMapResource = (
  latitude: string,
  longitude: string,
  addressName: string,
  id?: string,
  sub_type?: string,
  additional_info?: any
) => {
  return new Promise((resolve) => {
    console.log('openMapResource');
    nioJsBridge.invokeAnonymousBridge({
      name: 'openMapResource',
      data: { latitude, longitude, addressName, id, sub_type, additional_info },
      callback(e: any) {
        console.log('openMapResource', e);
        resolve(e);
      },
    });
  });
};
const openMap = async (
  latitude: string,
  longitude: string,
  addressName: string,
  id?: string,
  sub_type?: string,
  additional_info?: any,
  brand?: string
) => {
  const isHarmony = isHarmonyOS();
  const appInfo = await nioJsBridge.getAppInfo();
  const version = appInfo?.data?.version || '';
  let _brand = brand || 'nio'; // 'alps' | 'nio'
  console.log('openMap brand', brand);
  console.log('openMap appInfo', appInfo);
  if (_brand === 'fy') {
    console.log('openMap fy');

    if (!id || isHarmony) {
      return openMapNormal(latitude, longitude, addressName);
    }

    return openMapResource(
      latitude,
      longitude,
      addressName,
      id,
      sub_type,
      additional_info
    );
  }
  if (_brand === 'alps') {
    console.log('openMap alps');
    if (compareVersions(version, '1.8.0') < 0 || !id || isHarmony) {
      return openMapNormal(latitude, longitude, addressName);
    }
    return openMapResource(
      latitude,
      longitude,
      addressName,
      id,
      sub_type,
      additional_info
    );
  }
  if (_brand === 'nio') {
    console.log('openMap nio');
    if (compareVersions(version, '5.36.0') < 0 || !id || isHarmony) {
      return openMapNormal(latitude, longitude, addressName);
    }

    return openMapResource(
      latitude,
      longitude,
      addressName,
      id,
      sub_type,
      additional_info
    );
  }
  return Promise.resolve();
};

export default openMap;
